// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1sGQo","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__HEcxw"};